import { render, staticRenderFns } from "./AnnualRain.vue?vue&type=template&id=06e7c13e&scoped=true&"
import script from "./AnnualRain.vue?vue&type=script&lang=js&"
export * from "./AnnualRain.vue?vue&type=script&lang=js&"
import style0 from "./AnnualRain.vue?vue&type=style&index=0&id=06e7c13e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e7c13e",
  null
  
)

export default component.exports